module.exports = __webpack_public_path__ + "media/images/city_img/f-84b1005e52f198db4c56047e6cd29f56.jpg";